// Keep historical consignment notes intact; disable only new UI usage.
// Re-enable explicitly after product-level notes requirements are reviewed.
export const ENABLE_CONSIGNMENT_NOTES = false
